import { render, staticRenderFns } from "./ConversationPageV2.vue?vue&type=template&id=68cc0d00"
import script from "./ConversationPageV2.vue?vue&type=script&lang=js"
export * from "./ConversationPageV2.vue?vue&type=script&lang=js"
import style0 from "./ConversationPageV2.vue?vue&type=style&index=0&id=68cc0d00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports